<template>
  <div v-if="goods">
    <el-table :data="goods">
      <el-table-column prop="goodsNo" label="物品编号"/>
      <template v-if="goodsType==='成品'||goodsType==='坯布'">
        <el-table-column prop="weight" label="克重"/>
        <el-table-column prop="width" label="门幅"/>
      </template>
      <template v-if="goodsType==='纱线'">
        <el-table-column prop="artName" label="品名" width="140px"/>
        <el-table-column prop="width" label="纱支"/>
        <el-table-column prop="colorName" label="色号"/>
      </template>
      <template v-if="goodsType==='纤维'">
        <el-table-column prop="artName" label="名称"/>
        <el-table-column prop="standards" label="规格"/>
        <el-table-column prop="colorName" label="色号"/>
      </template>
      <el-table-column prop="blendName" label="成份"/>
      <el-table-column label="主数量" prop="mainQuantity"/>
      <el-table-column label="主单位" prop="mainQuantityUnit"/>
      <el-table-column label="含税单价" prop="taxUnitPrice"/>
      <el-table-column label="附加费" prop="otherFee" is-slot>
        <template slot-scope="scope">
          <span>{{ getFeeTotal(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税率（%）" prop="tax"/>
      <el-table-column label="总价" prop="totalPrice"/>
      <el-table-column label="溢短装" prop="moreOrLessClause">
        <template slot-scope="scope">
          <span v-if="scope.row.shortOverflow">
            +{{
              scope.row.shortOverflow.overflow
            }}% ～ -{{ scope.row.shortOverflow.shortV }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="交期" prop="deliveryTimeList" is-slot width="140px">
        <template slot-scope="scope">
          <div>
                <span v-if="utils.notEmptyArr(scope.row.deliveryTimeList)">
                  {{ scope.row.deliveryTimeList[0].time }}
                </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="el-icon-third-dingdan" @click="toSaleOrder(scope.row)"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
/**
 * @Description:
 * @Author: 菩萨蛮
 * @Date: 2021/4/15 11:41 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'SaleOrderRadioTableDialog',
  props: {
    orderId: { type: String, default: '' }
  },
  data() {
    return {
      goods: [],
      goodsType: '成品',
      order: null
    };
  },
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      if (!this.utils.isEmpty(this.orderId)) {
        const { data } = await this.qGet(`/sales/sale_contract/${this.orderId}`);
        const { isEmpty } = this.utils;
        this.goods = data.goods.filter(e => isEmpty(e.saleOrderNo));
        this.order = data;
      }
    },
    close() {
      this.$emit('close');
    },
    getFeeTotal(row) {
      const { sum } = this.math;
      if (!row.surchargeFeeList) {
        return 0;
      }
      return sum(row.surchargeFeeList.map(e => e.fee));
    },
    toSaleOrder(row) {
      this.$emit('toSaleOrder', {
        goods: {
          ...row,
          saleContractId: this.orderId
        },
        order: this.order
      });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
